import { IconType } from 'react-icons';
import { AiOutlineQuestion } from 'react-icons/ai';
import { ReactNode } from 'react';
import { ToolExecuteHandler } from '../../constants';
import { t } from '../../stores/TranslateStore';

export default class TabModel {
  readonly id: string;

  readonly iconType?: IconType;

  readonly text?: ReactNode | string;

  onExecute?: ToolExecuteHandler;

  isEnabled?: boolean;

  data: any;

  constructor(
    id: string,
    icon: IconType,
    text: ReactNode | string,
    onExecute?: ToolExecuteHandler,
    isEnabled?: boolean,
    data?: any,
  ) {
    this.id = id;
    this.iconType = icon;
    this.text = text || '##';
    this.onExecute = onExecute || (() => false);
    this.isEnabled = isEnabled || false;
    this.data = data || {};
  }

  get icon(): IconType {
    return this.iconType || AiOutlineQuestion;
  }

  // 표시 전용 번역 탭 라벨. 헤더 탭(HeaderTabView)이 이 값을 읽는다. text 는
  // 대부분 메뉴명(정적 라벨)이고, JSX 가 들어와도 t.T 가 그대로 통과시키므로
  // 안전하다. text(원문)는 그대로 두어 로직에는 영향이 없다.
  get textT(): ReactNode {
    return t.T(this.text);
  }
}
